export default "__VITE_ASSET__ChWBcBxw__"